<div class="ads-container">
  <div class="bg" (click)="showAd()"></div>

  <div class="block"  (click)="showAd()" [ngStyle]="{'background-image': 'url(' + (Ad?.getImage() | pipeWebp ) + ')'}"></div>

  <button class="close-float-right" mat-button color="white" (click)="close()"><mat-icon>highlight_off</mat-icon></button>
</div>
